import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Layout from "../../wrapper";
import { logInUserInfo } from "../../Actions/Users";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../Layout/Loader";
import axios from "axios";
import TextField from "../../Components/common/TextField";
import { FormControlLabel, Grid } from "@mui/material";
import Button from "../../Components/common/Button";
import InvoiceModal from "../../Components/GarageInvoices";
import Table from "../../Components/common/tableWithBackEndPagination";
import Table1 from "../../Components/common/TableServices";
import CustomDialog from "../../Components/common/Dialog";
import { checkPrivileges, getUserTimezone, withExportTimezone } from "../../Helpers";
import moment from "moment";
import withRoutes from "../../HOC/HocRoutes";
import Checkbox from "../../Components/common/Checkbox";
import MenuItem from "../../Components/common/MenuItem";
import UnitMenu from "../../Components/common/CommonMenu";
import SingleSelect from "../../Components/common/SingleSelect";

// import TableServices from "../../Components/common/TableServices";
let source;
let expenseMainTypes = [];
let garageList = [];
let servicesList = [];

class ContractManagment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisable: false,
      // loader: true,
      activeOperation: "",
      selectedItem: "",
      itemPrivileges: [],
      selectedAccount: {},
      selectedServices: {},
      selectedSubTypesAllServices: {},
      tableData: [],
      openTable: false,
      rowsPerPage: 5,
      openExpenseForm: false,
      expenseForm: {},
      isVisableSubmitBtn: true,
      mode: "create",
      onDeleteConfirmation: false,
      selectedServiceTypeId: "",
      invoicesData: [],
      searchInvoice: "",
      invoicesList: [],
      filteredData: false,
      loading: false,
      to: "",
      from: "",
      account: "",
      vehcile: "",
      area: "",
      showServices: false,
      page: 1,
      pageSize: 20,
      invoiceData: {},
      value: "maintenance",
      searchInvoiceText: "",
      openFilter: false,
      selectSingleInvoice: false,
      filterInvoices: "",
      contractNumber: "",
      leasing: false,
      showImportedInvoiceError: false,
      importedInvoiceData: {},
      singleAccount: false,
      showRegeneratedModal: false,
      bulkInvoicesDate: "",
      bulkInvoiceLoader: true,
      newTableData: [],
      accounts: "",
      contractType: 1,
      loader: false,
      loader1: false,
      servicesList: "",
      expenseMainTypes: [],
      openInvoiceForm: false,
      selectedMonth: "",
      selectedContractNumber: "",
      isVisableSubmitBtn1: false,

      countChecked: 0,
      anchorEl: null,
      statusFilter: [],
      garageCity: "",
      garageType: "",
      selectedGarageCity: "",
      isVisableFilterBtn: false,
      enableReset: false,
    };

    this.getGarageList = this.getGarageList.bind(this);
    this.selecteFilters = this.selecteFilters.bind(this);
  }
  // componentWillMount() {
  //   // this.props.dispatch(toast.removeAll());

  //   // expenseMainTypes = [];
  //   this.getContractsData();
  // }
  componentDidMount() {
    this.setState(
      {
        statusFilter: { 3: true },
        page: 1,
        countChecked: 1,
        pageSize: 20,
        value: "maintenance", // Example default value
        userTypes: "&userTypes=3", // Default userTypes
      },
      () => {
        this.getContractsData();
      }
    );
  }
  handleChangeTabs = (e) => {
    if (e === "leasing") {
      this.setState(
        {
          value: e,
          leasing: true,
          // cashCustomer:false
        },
        () => {
          this.getContractsData();
        }
      );
    } else if (e === "maintenance") {
      this.setState(
        {
          value: e,
          leasing: false,
          // cashCustomer:false
        },
        () => {
          this.getContractsData();
        }
      );
    } else if (e === "cashCustomer") {
      this.setState(
        {
          value: e,
          leasing: false,
          // cashCustomer:true
        },
        () => {
          this.getContractsData();
        }
      );
    }
    this.setState({
      pageSize: 20,
      rowsPerPage: 5,
      page: 1,
    });
  };
  getInvoiceApiNames = () =>
    this.props.invoiceApiNames || {
      maintenance: "garageinvoices",
      leasing: "garageleaseinvoices",
      cashCustomer: "garagecashinvoices",
    };

  getGarageList = async (id) => {
    let url = id ? `api/garages?get&userId=${id}` : `/api/garages`;
    let result = await axios.get(url);
    garageList =
      result &&
      result.data &&
      result.data.data &&
      result.data.data.map((item) => {
        return {
          id: item.id,
          key: item.id,
          name: item.name,
          label: item.name,
          uniqueId: item.id,
          valueType: "string",
        };
      });
    // console.log("result====", garageList);
    this.setState({ garageList: garageList });
  };

  getServicesList = async (id) => {
    let url = id
      ? `/api/services/due?&userId=${id}&page=1&limit=20`
      : `/api/services/due?page=1&limit=20`;
    // /api/services/due?page=1&limit=20
    let result = await axios.get(url);
    // console.log("serviceList====", result);
    servicesList =
      result &&
      result.data &&
      result.data.data &&
      result.data.data.data &&
      result.data.data.data.map((item) => {
        return {
          id: item.id,
          key: item.id,
          name: item.name,
          label: item.name,
          uniqueId: item.id,
          valueType: "string",
        };
      });

    this.setState({ servicesList: servicesList });
  };

  // componentDidMount() {

  // }

  addItem = () => {
    this.setState({
      isVisable: true,
      activeOperation: "add",
      selectedItem: "",
    });
  };
  removedItem = (item) => {
    this.setState({
      isVisable: true,
      activeOperation: "remove",
      selectedItem: item,
    });
  };
  editItem = (item) => {
    this.setState({
      isVisable: true,
      activeOperation: "edit",
      selectedItem: item,
    });
  };

  // ----------------------------- Filtered Invoices -----------------------------------
  selecteFilters = async (to, from, account, vehcile, area) => {
    this.setState(
      {
        // selectedAccount:item,
        to: to,
        from: from,
        account: account,
        vehcile: vehcile,
        area: area,
        page: 1,
        pageSize: 20,
        itemSearch: "",
        filteredData: true,
      },
      () => {
        this.getInvoices(to, from, account, vehcile, area);
      }
    );
  };

  invoiceSelection = (item) => {
    const selectedGarageId =
      item?.garageId || item?.id || item?.contractNumber || "";
    // this.fetchServices(item);
    // this.getServicesList(item)
    // this.getGarageList(item.userId);
    // this.getServicesList(item.userId);
    this.setState(
      {
        openFilter: true,
        selectSingleInvoice: true,
        // openFilter: false,
        singleAccount: true,
        selectedAccount: item,
        to: "",
        from: "",
        account: "",
        vehcile: "",
        area: "",
      },
      () => {
        this.getInvoices(
          this.state.to,
          this.state.from,
          selectedGarageId,
          this.state.vehcile,
          this.state.area
        );
      }
    );
  };
  getSelectedGarageId = () =>
    this.state.selectedAccount?.garageId ||
    this.state.selectedAccount?.id ||
    this.state.selectedAccount?.contractNumber ||
    "";

  fetchInvoices = async (id) => {
    // console.log("herer======");
    let { page, pageSize, searchInvoice } = this.state;
    const invoiceApiNames = this.getInvoiceApiNames();
    let api;

    if (id) {
      if (this.state.value === "maintenance") {
        api = `/api/${invoiceApiNames.maintenance}/get?garageId=${id}&page=${page}&limit=${pageSize}&invoiceNumber=${searchInvoice}`;
      } else if (this.state.value === "leasing") {
        api = `/api/${invoiceApiNames.leasing}/get?garageId=${id}&page=${page}&limit=${pageSize}&search=${searchInvoice}`;
      } else if (this.state.value === "cashCustomer") {
        api = `/api/${invoiceApiNames.cashCustomer}/get?garageId=${id}&page=${page}&limit=${pageSize}&search=${searchInvoice}`;
      }
    } else {
      if (this.state.value === "maintenance") {
        api = `/api/${invoiceApiNames.maintenance}/get?&page=${page}&limit=${pageSize}&invoiceNumber=${searchInvoice}`;
      } else if (this.state.value === "leasing") {
        api = `/api/${invoiceApiNames.leasing}/get?&page=${page}&limit=${pageSize}&search=${searchInvoice}`;

        // api = `/api/${invoiceApiNames.leasing}/get?cn=${id}&page=${page}&limit=${pageSize}&search=${searchInvoice}`;
      } else if (this.state.value === "cashCustomer") {
        api = `/api/${invoiceApiNames.cashCustomer}/get?&page=${page}&limit=${pageSize}&search=${searchInvoice}`;
        // api = `/api/${invoiceApiNames.cashCustomer}/get?cn=${id}&page=${page}&limit=${pageSize}&search=${searchInvoice}`;
      }
    }
    source = axios.CancelToken.source();
    await axios
      .get(api, {
        cancelToken: source.token,
      })
      .then((response) => {
        this.setState({
          invoicesData: response?.data?.data || [],
          openTable: true,
          filteredData: false,
          showServices: true,
          // loader: false,
        });
      })
      .catch((e) => {
        console.log("e ===", e);
      });
  };

  getInvoices = async (to, from, account, vehcile, area) => {
    // console.log("herer======");
    let { page, pageSize, searchInvoice, value, selectSingleInvoice } =
      this.state;
    // this.setState({loader:true})
    const invoiceApiNames = this.getInvoiceApiNames();
    let selectedInvoice =
      value === "maintenance"
        ? invoiceApiNames.maintenance
        : value === "leasing"
        ? invoiceApiNames.leasing
        : value === "cashCustomer"
        ? invoiceApiNames.cashCustomer
        : "";

let searchParam = "invoicenumber";

let apiUrl = `/api/${selectedInvoice}/get?`;
const normalizedAccount =
  typeof account === "string"
    ? account
        .replace(/&cn=/g, "&garageId=")
        .replace(/&contractNumber=/g, "&garageId=")
        .replace(/&account=/g, "&garageId=")
    : account;

// helper to append only existing params
const appendParam = (key, val) => {
  if (val) apiUrl += `&${key}=${val}`;
};

if (selectSingleInvoice) {
  // when single account is selected
  if (typeof normalizedAccount === "string" && normalizedAccount.includes("&")) {
    apiUrl += normalizedAccount;
  } else {
    appendParam("garageId", normalizedAccount);
  }
  appendParam("vehcile", vehcile);
  appendParam("area", area);
  appendParam(searchParam, searchInvoice);

  if (to) {
    appendParam("to", to);
    appendParam("from", from);
  }

  apiUrl += `&page=${page}&limit=${pageSize}`;
} else {
  // for all invoices
  if (to) {
    appendParam("to", to);
    appendParam("from", from);
    if (typeof normalizedAccount === "string" && normalizedAccount.includes("&")) {
      apiUrl += normalizedAccount;
    } else {
      appendParam("garageId", normalizedAccount);
    }
    appendParam("vehcile", vehcile);
    appendParam("area", area);
  }

  appendParam(searchParam, searchInvoice);
  apiUrl += `&page=${page}&limit=${pageSize}`;
}

    source = axios.CancelToken.source();
    this.setState(
      {
        loader: true,
      },
      () => {
        axios
          .get(apiUrl, {
            cancelToken: source.token,
          })
          .then((response) => {
            // console.log("response=====", response?.data?.data);
            this.setState({
              // filterInvoices: response?.data?.data || [],
              filterInvoices:
                response?.data?.data === "no invoices found"
                  ? {
                      page: 1,
                      hasNext: false,
                      data: [],
                      pageSize: 20,
                      total: 0,
                    }
                  : response?.data?.data || {},
              filteredData: true,
              // openTable: false,
              openTable: true,
              loader: false,
              openFilter: true,
              // showServices: false,
            });
          })
          .catch((e) => {
            // console.log("e ===", e);
          });
      }
    );
  };

  // getInvoices = async (to, from, account, vehcile, area) => {
  //   // console.log("herer======");
  //   let { page, pageSize, searchInvoice , value, selectSingleInvoice} = this.state;
  //   // this.setState({loader:true})
  //   let selectedInvoice =
  //     value === "maintenance" ? "invoices" : value === "leasing" ? "leaseinvoices" :
  //     value === "cashCustomer"?  "cashinvoices" :""
  //     ;
  //   let result;
  //   this.setState({ loader: true }, async () => {
  //   if (selectSingleInvoice) {
  //     if (to) {
  //       result = await axios.get(
  //         `/api/${selectedInvoice}/get?&to=${to}&from=${from}${account}${vehcile}${area}&page=${page}&limit=${pageSize}&search=${searchInvoice}`
  //       );

  //     } else {
  //       result = await axios.get(
  //         `/api/${selectedInvoice}/get?&contractNumber=${account}&page=${page}&limit=${pageSize}&search=${searchInvoice}`
  //       );
  //     }
  //   } else {
  //     if (to) {
  //       result = await axios.get(
  //         `/api/${selectedInvoice}/get?&to=${to}&from=${from}${account}${vehcile}${area}&page=${page}&limit=${pageSize}&search=${searchInvoice}`
  //       );
  //     } else {
  //       result = await axios.get(
  //         `/api/${selectedInvoice}/get?&page=${page}&limit=${pageSize}&search=${searchInvoice}`
  //       );
  //     }
  //   }

  //   this.setState({
  //     filterInvoices:  result?.data?.data || [],
  //     filteredData: true,
  //     // openTable: false,
  //     openTable: true,
  //     loader: false,
  //     openFilter: true,
  //     // showServices: false,
  //   });
  // });
  // };

  regenerateInvoices = async (to, from, account, invalidOnly) => {
    this.setState(
      {
        showRegeneratedModal: true,
      },
      () => this.regenerateBulkInvoices(to, from, account, invalidOnly)
    );
  };

  regenerateBulkInvoices = async (to, from, account, invalidOnly) => {
    let { page, pageSize, searchInvoice, selectedAccount } = this.state;
    const invoiceApiNames = this.getInvoiceApiNames();
    let result;
    if (this.state.singleAccount) {
      result = await axios.get(
        `/api/${invoiceApiNames.maintenance}/recompute?contractNumber=${selectedAccount.contractNumber}&from=${from}&to=${to}&invalidOnly=${invalidOnly}`
      );
    } else {
      result = await axios.get(
        `/api/${invoiceApiNames.maintenance}/recompute?${account}&from=${from}&to=${to}&invalidOnly=${invalidOnly}`
      );
    }

    const arr = Object.entries(result?.data?.data).map(([key, value]) => ({
      key,
      value,
    }));

    // const arr = Object.entries(result?.data?.data).map(([key, value]) => ({
    //   [key]: value,
    // }));
    this.setState({
      bulkInvoicesDate: arr,
      bulkInvoiceLoader: false,
    });
  };

  selecteItem = (item) => {
    this.setState(
      {
        selectedAccount: item,
        page: 1,
        pageSize: 20,
        itemSearch: "",
        filteredData: false,
      },
      () => {
        this.fetchInvoices(item.contractNumber);
      }
    );
  };

  saveData = (blob, filename) => {
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      const a = document.createElement("a");
      document.body.appendChild(a);
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = filename;
      a.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        // this.setState({ loading: false })
      }, 0);
    }
    // this.setState({ loading: false })
  };

  downloadInvoices = (
    to,
    from,
    account,
    vehcile,
    area,
    type,
    invoiceStatus
  ) => {
    let { leasing } = this.state;
    const invoiceApiNames = this.getInvoiceApiNames();
    let url;

    // console.log("invoiceStatus====d", invoiceStatus);
    let accept;
    if (type === "downloadPdf") {
      accept = "application/pdf";
    } else {
      accept =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    }
    let header;
    header = {
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: accept,
      }),
      method: "GET",
    };

    {
      checkPrivileges("invoiceInvalidView")
        ? (url = `/api/${invoiceApiNames.maintenance}/export?invoiceStatus=${invoiceStatus}&to=${to}&from=${from}${account}${vehcile}${area}`)
        : (url = `/api/${invoiceApiNames.maintenance}/export?to=${to}&from=${from}${account}${vehcile}${area}`);
    }
    url = withExportTimezone(url, getUserTimezone(this.props.logInUser));

    this.setState(
      {
        loader: true,
      },
      () => {
        try {
          
        fetch(
          url,
          // `/api/invoices/export?leasing=${leasing}&to=${to}&from=${from}${account}${vehcile}${area}`,
          { ...header }
        )
          .then((response1) => {
            if (response1.status === 200) {
              if (type === "downloadPdf") {
                response1.blob().then((response) => {
                  this.setState(
                    {
                      selectedAreaId: "",
                      selectedvehicleId: "",
                      to: "",
                      from: "",
                      loader: false,
                    },
                    () => {
                      this.saveData(response, "Invoices.pdf");
                    }
                  );
                });
              } else {
                response1.blob().then((response) => {
                  this.setState(
                    {
                      selectedAreaId: "",
                      selectedvehicleId: "",
                      to: "",
                      from: "",
                      loader: false,
                    },
                    () => {
                      this.saveData(response, "Invoices.xlsx");
                    }
                  );
                });
              }
            } else {
               console.warn("Download failed with status:", response1.status);
            this.setState({ loader: false });
            }
          })

          .catch((error) => {
              console.warn("Fetch error:", error?.message || error);
          this.setState({ loader: false });
          })
        } catch (error) {
             console.warn("Unexpected error:", error?.message || error);
      this.setState({ loader: false });
        }
      }
    );
  };

  fetchServices = (item) => {
    let id =
      item && item.userId
        ? item.userId
        : this.props.ServerSetting && this.props.ServerSetting.userId;
    let api =
        this.props.ServerSetting && this.props.ServerSetting.contractNumber
          ? `/api/expensetypes?userId=${id}`
          : `/api/expensetypes`,
      source = axios.CancelToken.source();
    axios
      .get(api, {
        cancelToken: source.token,
      })
      .then((response) => {
        response.data &&
          response.data &&
          response.data.data &&
          response.data.data.map((type) => {
            expenseMainTypes.push({
              key: type.id,
              id: type.id,
              type: type.name,
              name: type.name,
              subType: type.name,
            });
          });
        this.setState({ expenseMainTypes: expenseMainTypes });
        // }
      })
      .catch((e) => {
        console.log("e ===", e);
      });
  };

  onCloseModal = () => {
    this.setState({
      isVisable: false,
      activeOperation: "",
      selectedItem: "",
    });
    this.props.navigate("/contractManagement");
  };

  SearchItem = (searchValue) => {
    source.cancel();
    this.setState({
      page: 1,
      itemSearch: searchValue,
      // loader: true,
      defaultUserList: false,
    });
  };

  handleChange = (name, value) => {
    this.setState(
      {
        expenseForm: {
          ...this.state.expenseForm,
          [name]: value,
        },
      },
      () => {
        this.checkRequiredExpenses();
      }
    );
  };

  checkRequiredExpenses = () => {
    const { name, contractNumber } = this.state.expenseForm;
    if (name && contractNumber) {
      this.setState({ isVisableSubmitBtn: false });
    } else this.setState({ isVisableSubmitBtn: true });
  };

  closeExpenseForm = () => {
    this.setState({ openExpenseForm: false, mode: "create" });
  };

  submitExpenseForm = () => {
    let url =
      this.state.mode === "create"
        ? `/api/expensetypes/`
        : `/api/expensetypes/${this.state.expenseForm.id}`;
    fetch(url, {
      method: this.state.mode === "create" ? "POST" : "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...this.state.expenseForm,
      }),
    })
      .then((response) => {
        if (response.ok) {
          this.setState(
            { createSubType: false, openExpenseForm: false },
            () => {
              this.fetchAccountServices(this.state.selectedAccount.id);
            }
          );

          toast.success(
            this.state.mode === "create"
              ? this.props.translate("serviceCreated")
              : this.props.translate("serviceUpdated")
          );
        }
      })
      .catch((error) => {
        console.log("error ==", error);
      });
  };

  editExpenseForm = (item) => {
    this.setState({
      expenseForm: item,
      openExpenseForm: true,
      mode: "update",
      openTable: false,
    });
  };

  onCancel = () => {
    this.setState({
      onDeleteConfirmation: false,
    });
  };

  searchItem = (e) => {
    let text = e.target.value;
    const u =
      this.state.allServicesList &&
      this.state.allServicesList.data &&
      this.state.allServicesList.data.filter((u) =>
        (u.id + u.name).toLowerCase().includes(text.toLowerCase())
      );
    this.setState({ selectedServices: u });
  };

  searchInvoices = (e) => {
    source.cancel();
    // if (this.state.filteredData || this.state.showServices) {
    this.setState({ searchInvoice: e.target.value,page:1 }, () => {
      this.getInvoices(
        this.state.to,
        this.state.from,
        this.state.account || this.getSelectedGarageId(),
        this.state.vehcile,
        this.state.area
      );
    });
    // }
    // else {
    //   this.setState({ searchInvoice: e.target.value }, () => {
    //     this.fetchInvoices(this.state.selectedAccount.contractNumber);
    //   });
    // }
  };

  setPagination = () => {
    let nAcc;

    if (
      this.state.openFilter ||
      this.state.filteredData ||
      this.state.showServices
    ) {
      nAcc = { ...this.state.filterInvoices };
    }
    // else if (this.state.showServices) {
    //   nAcc = { ...this.state.invoicesData };
    // }
    else {
      nAcc = { ...this.state.invoiceData };
    }

    let lastPage = nAcc.total / this.state.pageSize;
    let IsFloate = this.checkFloteNumber(lastPage);
    delete nAcc.data;
    nAcc.pageSize = this.state.pageSize;
    nAcc.lastPage = IsFloate ? parseInt(lastPage + 1) : lastPage;
    return nAcc;
    // }
    // return {}
  };

  handleChangeRowsPerPage = (value) => {
    if (
      this.state.openFilter ||
      this.state.filteredData ||
      this.state.showServices
    ) {
      this.setState({ page: 1, pageSize: value }, () =>
        this.getInvoices(
          this.state.to,
          this.state.from,
          this.state.account || this.getSelectedGarageId(),
          this.state.vehcile,
          this.state.area
        )
      );
    } else {
      this.setState({ page: 1, pageSize: value }, () =>
        this.getContractsData()
      );
    }
  };

  handleChangePage = (value) => {
    if (
      this.state.openFilter ||
      this.state.filteredData ||
      this.state.showServices
    ) {
      this.setState({ page: value }, () =>
        this.getInvoices(
          this.state.to,
          this.state.from,
          this.state.account || this.getSelectedGarageId(),
          this.state.vehcile,
          this.state.area
        )
      );
    } else {
      this.setState({ page: value }, () => this.getContractsData());
    }
  };

  checkFloteNumber(n) {
    return Number(n) === n && n % 1 !== 0;
  }

  goBack = () => {
    this.setState({
      // this.state.openFilter ||
      // this.state.filteredData ||
      // this.state.showServices
      // cashCustomer:false,
      searchInvoice: "",
      singleAccount: false,
      openTable: false,
      showServices: false,
      filteredData: false,
      openFilter: false,
      selectSingleInvoice: false,
    });
  };

  searchInvoiceText = (e) => {
    source.cancel();
    this.setState(
      {
        searchInvoiceText: e.target.value,
      },
      () => {
        this.getContractsData();
      }
    );
  };
  checkSearchFields = () => {
    const { garageCity, garageType } = this.state;
    this.setState({
      isVisableFilterBtn: Boolean(garageCity || garageType),
    });
  };
  searchGarageFilters = (e, name) => {
    source.cancel();
    if (name === "garageType") {
      this.setState({ garageType: e.target.value }, () => this.checkSearchFields());
    } else if (e === "garageCity") {
      this.setState(
        { garageCity: name?.id || "", selectedGarageCity: name || "" },
        () => this.checkSearchFields()
      );
    } else {
      this.searchInvoiceText(e);
    }
  };
  getGarages = () => {
    this.setState({ enableReset: true, page: 1 }, () => this.getContractsData());
  };
  resetGarages = () => {
    this.setState(
      {
        garageCity: "",
        garageType: "",
        selectedGarageCity: "",
        isVisableFilterBtn: false,
        enableReset: false,
        page: 1,
      },
      () => this.getContractsData()
    );
  };

  openImportTable = (item) => {
    const array = Object.entries(item).map(([invoiceNo, msg]) => ({
      invoiceNo: parseInt(invoiceNo),
      msg,
    }));
    this.setState({
      showImportedInvoiceError: true,
      importedInvoiceData: array,
    });
  };

  onCloseImportedModal = () => {
    this.setState({
      showImportedInvoiceError: false,
      showRegeneratedModal: false,
      // bulkInvoicesDate: "",
    });
  };

  openFilter = () => {
    this.setState(
      {
        to: "",
        from: "",
        account: "",
        vehcile: "",
        area: "",
        openFilter: true,
        singleAccount: false,
        selectSingleInvoice: false,
        openInvoiceForm: false,

        // loader: true,
        // pageSize:-1
      },
      () => {
        this.getInvoices(
          this.state.to,
          this.state.from,
          this.state.account,
          this.state.vehcile,
          this.state.area
        );
        // ; this.getMoreAccounts()
      }
    );
  };
  getContractsData = () => {
    let { page, pageSize, searchInvoiceText, garageCity, garageType } = this.state;
    const params = new URLSearchParams({
      userId: this.props.logInUser?.id,
      all: true,
      page,
      limit: pageSize,
      search: searchInvoiceText || "",
      ...(garageCity && { garageCity }),
      ...(garageType && { garageType }),
    });
    const apiUrl = `/api/garages/get?${params.toString()}`;
    source = axios.CancelToken.source();

    this.setState(
      {
        loader1: true,
        contractType: 1,
      },
      () => {
        axios
          .get(apiUrl, {
            cancelToken: source.token,
          })
          .then((response) => {
            this.setState({
              invoiceData: response?.data?.data || {},
              loader1: false,
              enableReset: this.state.isVisableFilterBtn ? true : false,
            });
          })
          .catch((e) => {
            console.log("e ===", e);
          });
      }
    );
  };
    getCashCustomerAccounts = () => {
    let { page, pageSize, searchInvoiceText, value, openFilter, userTypes } =
      this.state;


    let apiUrl;
 if (value === "cashCustomer") {
      apiUrl = `/api/accounts/list?all=true&contractType=3&userTypes=3&userId=${this.props.logInUser.id}&limit=-1`;
    }
    source = axios.CancelToken.source();

    this.setState(
      {
        loader1: true,
      },
      () => {
        axios
          .get(apiUrl, {
            cancelToken: source.token,
          })
          .then((response) => {
            this.setState({
              invoiceAccountList: response?.data?.data || {},
              loader1: false,
            });
          })
          .catch((e) => {
            console.log("e ===", e);
          });
      }
    );
  };

  getMoreAccounts = (id) => {
    let cc =
      this.state.value === "maintenance"
        ? 1
        : this.state.value === "leasing"
        ? 2
        : this.state.value === "cashCustomer"
        ? 3
        : "";
    let { page, pageSize, searchInvoiceText } = this.state;
    let apiUrl;
    if (id === "create") {
      apiUrl = `/api/accounts/get?userId=${this.props.logInUser.id}&all=true&limit=-1&search=${searchInvoiceText}`;
    } else {
      apiUrl = `/api/accounts/get?userId=${this.props.logInUser.id}&contractType=${cc}&all=true&page=${page}&limit=-1&search=${searchInvoiceText}`;
    }
    source = axios.CancelToken.source();

    this.setState(
      {
        accounts: [],
        // pageSize:newPageSize,
        // loader: true // set loader to true
      },
      () => {
        axios
          .get(apiUrl, {
            cancelToken: source.token,
          })
          .then((response) => {
            if (response.status === 200) {
              // this.props.dispatch(getAccounts(response.data.data));
              this.setState({
                accounts: response?.data?.data.data || {},
                // loader: false
              });
            }
          })
          .catch((e) => {
            // if (axios.isCancel(e)) {
            //   console.log('Request canceled = ', e);
            // }
          });
      }
    );
  };

  openInvoiceForm = () => {
    this.setState(
      {
        // openFilter: true,
        singleAccount: false,
        selectSingleInvoice: false,
        openFilter: false,
        openInvoiceForm: true,
      },
      () => this.getMoreAccounts("create")
    );
  };
  closeInvoiceForm = () => {
    this.setState({
      singleAccount: false,
      openTable: false,
      showServices: false,
      filteredData: false,
      openFilter: false,
      selectSingleInvoice: false,
      openInvoiceForm: false,
      selectedMonth: "",
      selectedContractNumber: "",
    });
  };

  handleChangeInvoiceCreate = (name, value) => {
    let timezone = "";
    if (
      this.props.logInUser &&
      this.props.logInUser.attributes &&
      this.props.logInUser.attributes.timezone
    ) {
      timezone = this.props.logInUser.attributes.timezone;
    }
    moment.tz.setDefault(timezone);
    if (name === "selectedMonth") {
      let val = moment(value).startOf("month").startOf("day").utc().format();
      this.setState(
        {
          [name]: val.toString(),
        },
        () => this.checkDates()
      );
    } else {
      this.setState(
        {
          selectedContractNumber: value,
        },
        () => this.checkDates()
      );
    }
  };

  checkDates = () => {
    const { selectedContractNumber, selectedMonth } = this.state;
    if (selectedMonth && selectedContractNumber) {
      this.setState({ isVisableSubmitBtn1: true });
    } else {
      this.setState({ isVisableSubmitBtn1: false });
    }
  };

  submitCreateInvoice = async () => {
    let { selectedMonth, selectedContractNumber } = this.state;
    const invoiceApiNames = this.getInvoiceApiNames();
    let result = await axios.get(
      `api/${invoiceApiNames.maintenance}/monthlyinvoice?contractNumber=${selectedContractNumber?.contractNumber}&month=${selectedMonth}`
    );
    if (result && result.data.status === "success") {
      this.setState({
        singleAccount: false,
        openTable: false,
        showServices: false,
        filteredData: false,
        openFilter: false,
        selectSingleInvoice: false,
        openInvoiceForm: false,
        selectedMonth: "",
        selectedContractNumber: "",
        isVisableSubmitBtn1: false,
      });

      toast.success("success");
    } else {
      toast.error("fail");
    }
  };

  openFilter1 = () => {
    this.setState({
      openFilter1: !this.state.openFilter1,
    });
  };
  handleClickFilter = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };
  handleCloseFilter = () => {
    this.setState({ anchorEl: null });
  };
  handleChangeFilter = (name, event) => {
    this.setState(
      (prevState) => {
        // Update the statusFilter and count of selected checkboxes
        const updatedStatusFilter = {
          ...prevState.statusFilter,
          [name]: event.target.checked,
        };

        // Generate `userTypes` query string
        const userTypes = Object.keys(updatedStatusFilter)
          .filter((key) => updatedStatusFilter[key]) // Include only checked filters
          .map((key) => `&userTypes=${key}`)
          .join("");

        return {
          statusFilter: updatedStatusFilter,
          countChecked:
            Object.values(updatedStatusFilter).filter(Boolean).length,
          userTypes,
          page: 1,
        };
      },
      () => {
        this.getContractsData(); // Fetch updated data
      }
    );
  };

  render() {
    if (this.props.logInUser) {
      return (
        <Layout
          {...this.props}
          {...this.state}
          contractType={this.state.contractType}
          getCashCustomerAccounts={this.getCashCustomerAccounts}
          // getContractsData={this.getMoreAccounts}
          SearchItem={this.SearchItem}
          addItem={this.addItem}
          selecteFilters={this.selecteFilters}
          selecteItem={this.selecteItem}
          removedItem={this.removedItem}
          translate={this.props.translate}
          editItem={this.editItem}
          downloadInvoices={this.downloadInvoices}
          regenerateInvoices={this.regenerateInvoices}
          noSidebar={
            this.state.openFilter || this.state.selectSingleInvoice
              ? ""
              : "noSidebar"
          }
        >
          {!this.state.showServices &&
          !this.state.openFilter &&
          !this.state.openInvoiceForm ? (
            <>
              <Grid container className="breadcrumb-row">
                <Grid item xs={12} sm={2}>
                  <h3 style={{ margin: 0 }}>
                    {this.props.translate("workshopInvoices")}
                  </h3>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={10}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <div style={{ width: "25%", marginRight: 20 }}>
                    <SingleSelect
                      array={this.props.cities || []}
                      async
                      selectName="garageCity"
                      isClearable
                      label={this.props.translate("workshopCity")}
                      value={
                        this.state.selectedGarageCity
                          ? {
                              id: this.state.selectedGarageCity?.id,
                              value:
                                this.state.selectedGarageCity?.cityEn ||
                                this.state.selectedGarageCity?.name,
                              label:
                                this.state.selectedGarageCity?.cityEn ||
                                this.state.selectedGarageCity?.name,
                            }
                          : ""
                      }
                      hidebg
                      handleChange={this.searchGarageFilters}
                      canAssign
                      menuPlacement="auto"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                  <div style={{ width: "25%", marginRight: 20 }}>
                    <TextField
                      fullWidth
                      label={this.props.translate("workshopType")}
                      value={this.state.garageType}
                      onChange={(e) => this.searchGarageFilters(e, "garageType")}
                    />
                  </div>
                  <div style={{ width: "15%", marginRight: 20 }}>
                    <Button
                      aria-label="search"
                      size="small"
                      color="inherit"
                      disabled={!this.state.isVisableFilterBtn}
                      onClick={this.getGarages}
                      id="search"
                    >
                      {this.props.translate("search")}
                    </Button>
                  </div>
                  <div style={{ width: "15%", marginRight: 10 }}>
                    <Button
                      aria-label="reset"
                      size="small"
                      color="inherit"
                      disabled={!this.state.enableReset}
                      onClick={this.resetGarages}
                      id="reset"
                    >
                      {this.props.translate("reset")}
                    </Button>
                  </div>
                  {/* <div style={{ width: "15%", marginRight: 5, marginTop: 6 }}>
                    <Button
                      // disabled={devices.data && devices.data.length === 0}
                      aria-label="filter"
                      size="small"
                      color="inherit"
                      onClick={this.openInvoiceForm}
                      style={{ marginRight: "10px" }}
                    >
                      {this.props.translate("sharedCreate")}
                    </Button>
                  </div> */}
                  <div style={{ width: "15%", marginRight: 5, marginTop: 6 }}>
                    <Button
                      aria-label="filter"
                      size="small"
                      color="inherit"
                      onClick={this.openFilter}
                      style={{ marginRight: "10px" }}
                    >
                      {this.props.translate("allPo")}
                    </Button>
                  </div>
                  {/* <div style={{ width: "20%", marginRight: 5, marginTop: 6 }}>
                    {this.state.openFilter1 && (
                      <div style={{ marginRight: 20 }}>
                        <Filter
                          countChecked={this.state.countChecked}
                          anchorEl={this.state.anchorEl}
                          handleChangeFilter={this.handleChangeFilter}
                          handleClickFilter={this.handleClickFilter}
                          handleCloseFilter={this.handleCloseFilter}
                          statusFilter={this.state.statusFilter}
                          userType={this.props.logInUser.userType}
                        />
                      </div>
                    )}
                    {!this.state.openFilter1 && (
                      <Button
                        aria-label="filter"
                        size="small"
                        color="inherit"
                        onClick={this.openFilter1}
                        style={{ marginRight: "20px" }}
                      >
                        {this.props.translate("filter")}
                      </Button>
                    )}
                  </div> */}
                  <div style={{ width: "25%", marginRight: 20 }}>
                    <TextField
                      fullWidth
                      label={this.props.translate("search")}
                      value={this.state.searchInvoiceText}
                      onChange={(e) => this.searchInvoiceText(e)}
                    />
                  </div>
                  {/* <div style={{ width: "10%", marginRight: 5, marginTop: 6 }}>
                    <ExportImportMenu
                      fileName="invoices"
                      checkPrivilege="serviceCreate"
                      isServices
                      data={this.state?.invoicesData?.data || []}
                      themecolors={this.props.themecolors}
                      categoryName={this.state?.selectedServiceTypeId || ""}
                      openImportTable={this.openImportTable}
                      noPdf
                    />
                  </div> */}
                </Grid>
              </Grid>

              {this.state.loader1 ? (
                <Loader />
              ) : (
                <Table
                  rows={
                    (this.state.invoiceData && this.state.invoiceData.data) ||
                    []
                  }
                  pagination={this.setPagination()}
                  handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                  handleChangePage={this.handleChangePage}
                  SearchItem={this.SearchItem}
                  onClick={this.invoiceSelection}
                  btnName1={"accounts"}
                  rowsPerPage={15}
                  translate={this.props.translate}
                  isEditable={true}
                  themecolors={this.props.themecolors}
                  filterDropdown
                  // setSerialNo
                  isCursoPointer
                  rowDefinition={
                    [
                      {
                        id: "name",
                        numeric: false,
                        disablePadding: false,
                        label: this.props.translate("name"),
                      },
                      {
                        id: "garageNumber",
                        numeric: false,
                        disablePadding: false,
                        label: this.props.translate("workshopNumber"),
                      },
                      {
                        id: "garageArea",
                        numeric: false,
                        disablePadding: false,
                        label: this.props.translate("workshopArea"),
                      },
                      {
                        id: "garageManager",
                        numeric: false,
                        disablePadding: false,
                        label: this.props.translate("workshopManager"),
                      },
                      {
                        id: "email",
                        numeric: false,
                        disablePadding: false,
                        label: this.props.translate("email"),
                      },
                      {
                        id: "phone",
                        numeric: false,
                        disablePadding: false,
                        label: this.props.translate("sharedPhone"),
                      },
                    ]
                  }
                />
              )}
            </>
          ) : null}

          {(this.state.openTable && this.state.showServices) ||
          this.state.openInvoiceForm ||
          this.state.openFilter ? (
            <>
              <Grid
                style={{ flex: 1, flexDirection: "row", background: "#fff" }}
              >
                <InvoiceModal
                  {...this.state}
                  translate={this.props.translate}
                  closeInvoiceForm={this.closeInvoiceForm}
                  handleChangeInvoiceCreate={this.handleChangeInvoiceCreate}
                  invoicesData={
                    this.state.openFilter || this.state.filteredData
                      ? this.state.filterInvoices
                      : this.state.invoicesData
                  }
                  // invoicesData={this.state.invoicesData}
                  submitCreateInvoice={this.submitCreateInvoice}
                  selectedSubTypesAllServices={
                    this.state.selectedSubTypesAllServices
                  }
                  handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                  // rowsPerPage={this.state.rowsPerPage}
                  getMoreAccounts={this.getMoreAccounts}
                  // this.getServicesList(item)
                  getGarageList={this.getGarageList}
                  fetchServices={this.fetchServices}
                  getServicesList={this.getServicesList}
                  handleChangePage={this.handleChangePage}
                  searchInvoices={this.searchInvoices}
                  themecolors={this.props.themecolors}
                  selectedServiceTypeId={
                    this.state?.selectedServiceTypeId || ""
                  }
                  selectService={this.selectService}
                  setPagination={this.setPagination}
                  expenseMainTypes={expenseMainTypes}
                  selectedAccount={this.state?.selectedAccount || {}}
                  fetchInvoices={this.fetchInvoices}
                  getInvoices={this.getInvoices}
                  searchInvoice={this.state.searchInvoice}
                  // servicesList={servicesList}
                  // garageList={garageList}
                  goBack={this.goBack}
                  openDnView={() => this.props.navigate("/garage-invoices/view")}
                  getCashCustomerAccounts={this.getCashCustomerAccounts}
                  garageInvoices
                  leasing={this.state.value === "maintenance" ? false : true}
                />
              </Grid>
            </>
          ) : null}

          {this.state.showRegeneratedModal && (
            <CustomDialog
              title="Regenerated Invoice"
              visable={true}
              onClose={this.onCloseImportedModal}
              bodyPadding={10}
              hideDragIcon
              fullWidth
              isVisableBtn
              // noFullScreen
            >
              {this.state.bulkInvoiceLoader ? (
                <Loader component="filter" defaultStyle />
              ) : (
                <Table1
                  rows={
                    (this.state.bulkInvoicesDate &&
                      this.state.bulkInvoicesDate) ||
                    []
                  }
                  // pagination={this.setPagination()}
                  // handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                  // handleChangePage={this.handleChangePage}
                  // SearchItem={this.SearchItem}
                  // onClick={this.invoiceSelection}
                  // btnName1={"accounts"}
                  rowsPerPage={10}
                  // isEditable={true}
                  themecolors={this.props.themecolors}
                  translate={this.props.translate}
                  // filterDropdown
                  // setSerialNo
                  isCursoPointer
                  rowDefinition={[
                    {
                      id: "key",
                      numeric: false,
                      disablePadding: false,
                      label: this.props.translate("invoiceNumber"),
                    },
                    {
                      id: "value",
                      numeric: false,
                      disablePadding: false,
                      label: this.props.translate("invoiceResponse"),
                    },
                  ]}
                />
              )}
            </CustomDialog>
          )}

          {this.state.showImportedInvoiceError && (
            <CustomDialog
              title="Imported Invoice"
              visable={true}
              onClose={this.onCloseImportedModal}
              bodyPadding={10}
              hideDragIcon
              fullWidth
              isVisableBtn
              noFullScreen
            >
              <Table1
                rows={this.state.importedInvoiceData || []}
                rowsPerPage={10}
                // isEditable={true}
                themecolors={this.props.themecolors}
                translate={this.props.translate}
                // filterDropdown
                // setSerialNo
                isCursoPointer
                rowDefinition={[
                  {
                    id: "invoiceNo",
                    numeric: false,
                    disablePadding: false,
                    label: this.props.translate("invoiceNumber"),
                  },
                  {
                    id: "msg",
                    numeric: false,
                    disablePadding: false,
                    label: this.props.translate("invoiceResponse"),
                  },
                ]}
              />

              {/* <div>
                <table>
                  <tr
                    style={{
                      borderBottom: "1px solid black",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <td>
                      <strong>Invoice no</strong>
                    </td>
                    <td>
                      <strong>Error</strong>
                    </td>
                  </tr>

                  {Object.entries(this.state.importedInvoiceData).map(
                    (item, i) => {
                      return (
                        <tr
                          style={{
                            borderBottom: "1px solid black",
                            paddingTop: 2,
                          }}
                        >
                         {console.log("===importInvoice", item)}
                          <td style={{ padding: 10 }}>
                            <strong>{item[0]}</strong>
                          </td>
                          <td style={{ padding: 10 }}>{item[1]}</td>
                        </tr>
                      );
                    }
                  )}
                </table>
              </div> */}
            </CustomDialog>
          )}
        </Layout>
      );
    } else {
      fetch(
        "/api/session?app=3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05",
        {
          headers: { Accept: "application/json; odata=verbose" },
        }
      )
        .then((response) => {
          if (response.ok) {
            response.json().then((res) => {
              if (res.status === "success") {
                let userInfo = res.data;
                this.props.setActiveLanguage(
                  userInfo?.attributes?.lang || "en"
                );
                this.props.dispatch(logInUserInfo(userInfo));
              } else if (res?.statusCode === "440") {
                window.location.replace("/login");
              } else if (res.statusCode) {
                var err = res?.message.split(":");
                err[1] = err[1].replace(")", "");

                toast.error(this.props.translate(err[1]));
                this.props.navigate("/login");
              }
            });
          } else {
            this.props.navigate("/login");
            throw response;
          }
        })
        .catch((e) => {
          toast.error("somethingWentWrong");
        });
      return null;
    }
  }
}

const Filter = (props) => {
  const html = (
    <div>
      <a
        className="v-filter-field"
        href={null}
        aria-owns={props.anchorEl ? "simple-menu" : undefined}
        aria-haspopup="true"
        onClick={props.handleClickFilter}
      >
        {props.countChecked} Selected
      </a>
      <UnitMenu
        id="simple-menu"
        anchorEl={props.anchorEl}
        open={Boolean(props.anchorEl)}
        onClose={props.handleCloseFilter}
      >
        <MenuItem
          component={FormControlLabel}
          style={{ margin: 0, paddingTop: 0, paddingBottom: 0 }}
          control={
            <Checkbox
              name="user"
              checked={props.statusFilter[1]}
              onChange={(e) => props.handleChangeFilter("1", e)}
              canAssign
              canRemove
            />
          }
          label="User"
        />
        <MenuItem
          component={FormControlLabel}
          style={{ margin: 0, paddingTop: 0, paddingBottom: 0 }}
          control={
            <Checkbox
              name="admin"
              checked={props.statusFilter[2]}
              onChange={(e) => props.handleChangeFilter("2", e)}
              canAssign
              canRemove
            />
          }
          label="Admin"
        />
        {(props.userType > 3 || props?.userType === -1) && (
          <MenuItem
            component={FormControlLabel}
            style={{ margin: 0, paddingTop: 0, paddingBottom: 0 }}
            control={
              <Checkbox
                name="adminAccount"
                checked={props.statusFilter[3]}
                onChange={(e) => props.handleChangeFilter("3", e)}
                canAssign
                canRemove
              />
            }
            label="Admin Account"
          />
        )}
        {(props.userType > 4 || props?.userType === -1) && (
          <MenuItem
            component={FormControlLabel}
            style={{ margin: 0, paddingTop: 0, paddingBottom: 0 }}
            control={
              <Checkbox
                name="ServiceProvider"
                checked={props.statusFilter[4]}
                onChange={(e) => props.handleChangeFilter("4", e)}
                canAssign
                canRemove
              />
            }
            label="Service Provider"
          />
        )}
        {(props.userType > 5 || props?.userType === -1) && (
          <MenuItem
            component={FormControlLabel}
            style={{ margin: 0, paddingTop: 0, paddingBottom: 0 }}
            control={
              <Checkbox
                name="Reseller"
                checked={props.statusFilter[5]}
                onChange={(e) => props.handleChangeFilter("5", e)}
                canAssign
                canRemove
              />
            }
            label="Reseller"
          />
        )}
        {props.userType === -1 && (
          <MenuItem
            component={FormControlLabel}
            style={{ margin: 0, paddingTop: 0, paddingBottom: 0 }}
            control={
              <Checkbox
                name="Distributor"
                checked={props.statusFilter[6]}
                onChange={(e) => props.handleChangeFilter("6", e)}
                canAssign
                canRemove
              />
            }
            label="Distributor"
          />
        )}
      </UnitMenu>
    </div>
  );
  return <div>{html}</div>;
};

const ExpenseForm = ({
  form,
  handleChange,
  translate,
  submitForm,
  closeEditForm,
  mode,
  isVisableSubmitBtn,
  checkPrivileges,
}) => {
  return (
    <div style={{ padding: 10 }}>
      <h4 className="page-title">{translate("services")}</h4>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            id="name"
            required
            margin="dense"
            label={translate("sharedName")}
            variant="outlined"
            fullWidth
            value={form?.name || ""}
            onChange={(e) => handleChange("name", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            id="description"
            margin="dense"
            label={translate("description")}
            variant="outlined"
            fullWidth
            value={form?.description || ""}
            onChange={(e) => handleChange("description", e.target.value)}
          />
        </Grid>
        {/* <Grid item xs={12} sm={6} md={4} lg={3}>
            <TextField
              id='customerNumber'
              margin='dense'
              label={translate('Customer Number')}
              variant='outlined'
              fullWidth
              value={form?.customerNumber || ''}
              onChange={e => handleChange('customerNumber', e.target.value)}
            />
          </Grid> */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            id="contractNumber"
            margin="dense"
            label={translate("contractNumber")}
            variant="outlined"
            fullWidth
            readOnly
            // type='number'
            value={form?.contractNumber || ""}
            // onChange={e => handleChange('contractNumber', e.target.value)}
          />
        </Grid>
      </Grid>
      <div style={{ display: "flex", marginTop: 10 }}>
        <div style={{ marginLeft: "auto" }} />
        <Button
          size="small"
          style={{ marginRight: 15 }}
          className="button-white"
          onClick={closeEditForm}
        >
          {translate("sharedCancel")}{" "}
        </Button>
        {checkPrivileges("expensetypeCreate") && (
          <Button
            size="small"
            onClick={submitForm}
            disabled={isVisableSubmitBtn}
          >
            {translate(mode === "update" ? "update" : "sharedCreate")}
          </Button>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  accounts: state.accounts,
  ServerSetting: state.ServerSetting,
  logInUser: state.logInUsers,
  themecolors: state.themecolors,
  cities: state.Cities?.cities || [],
});

export default connect(mapStateToProps)(withRoutes(ContractManagment));
